<template>
  <r-button icon="close" v-on="$listeners" unelevated round/>
</template>

<script>
import RButton from '@/components/base/RButton';

export default {
  name: 'CloseDialogButton',
  components: { RButton },
};
</script>
